import { getRegularApiClient } from "../utils/kiota-client";

export interface SetPrimaryCharacteristicPayload {
  productCode: number;
  characteristicCode: string;
}

/**
 * Sets a characteristic as the primary characteristic for a product.
 * Only one characteristic can be primary per product.
 */
export async function setPrimaryCharacteristic(
  payload: SetPrimaryCharacteristicPayload,
): Promise<void> {
  const client = getRegularApiClient();

  await client.api.vWithVersion("1").regulatoryCharacteristics.setPrimary.post({
    queryParameters: {
      productCode: payload.productCode,
      characteristicCode: payload.characteristicCode,
    },
  });
}
